import styled from '@emotion/styled';

export const ContentWrapper = styled.div`
  padding: 8px;
  background-color: ${({ theme }) => theme.colors.zinc_500};
  border-radius: 4px;
  box-shadow: ${({ theme }) => theme.elevation.md};
`;
